import FieldToggle from "../../../generic/boolean/toggle/toggle";
import FieldConfig from "../../../proto/field-config";
import FieldTimeReportIsBillable_ViewProperty from "./render/property";

export default class FieldTimeReportIsBillable extends FieldToggle {

    constructor(config:FieldConfig) {
        super(config)

        this.renderComponents.viewProperty = FieldTimeReportIsBillable_ViewProperty
    }
}